// const envType = "LOCAL";
// const envType = 'DEV';
// const envType = 'STAGE';
// const envType = "PRE_PROD";
const envType = 'PRODUCTION';

const redirectAzureUrl = (() => {
  switch (envType) {
    case "STAGE":
      return "https://myclnq.co/stage/fv-cmd/";
    case "PRE_PROD":
      return "https://cmd-preprod.fvhospital.com/";
    case "PRODUCTION":
      return "https://cmd.fvhospital.com/";
    case "LOCAL":
      return "http://localhost:3000/";
    case "DEV":
      return "http://localhost:3001/";
    default:
      return "https://cmd.fvhospital.com/";
  }
})();

const apiURL = (() => {
  switch (envType) {
    case "STAGE":
      return "https://backend-stage.fvhospital.com/";
    case "PRE_PROD":
      return "https://backend-preprod.fvhospital.com";
    case "PRODUCTION":
      return "https://backend.fvhospital.com";
    case "LOCAL":
      return "https://backend-stage.fvhospital.com/";
    case "DEV":
      return "http://localhost:3000/";
    default:
      return "https://backend.fvhospital.com";
  }
})();

const environment = {
  redirectAzureUrl,
  apiURL,
  envType,
};

export default environment;
